import { Flex, Table, Heading, Box } from '@radix-ui/themes';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useDroppable } from '@dnd-kit/core';

import GoalRow from './GoalRow.jsx';
import NewGoalForm from './NewGoalForm.jsx';

const YearTable = ({
  year,
  yearGoals,
  isAddingToThisYear,
  newGoal,
  setNewGoal,
  onAddGoal,
  onCancelAdd,
  onKeyDown,
  editingId,
  editData,
  setEditData,
  startEditing,
  saveEdit,
  cancelEdit,
  deleteGoal,
  copyGoal,
  recentlyMovedGoalId,
  currentTargetPosition,
  activeGoal,
}) => {
  const { setNodeRef } = useDroppable({
    id: `year-${year}`,
    data: {
      type: 'year',
      year: parseInt(year, 10),
    },
  });

  return (
    <Flex direction="column" ref={setNodeRef}>
      <Box
        style={{
          padding: '20px 24px',
          backgroundColor: 'var(--blue-contrast)',
          borderRadius: '8px 8px 0 0',
          border: '1px solid var(--gray-4)',
          height: '60px',
        }}
      >
        <Heading size="4" m="0">
          {year}
        </Heading>
      </Box>
      <Table.Root
        variant="surface"
        style={{
          borderTop: 'none',
          borderRadius: '0 0 8px 8px',
          borderColor: 'var(--gray-4)',
        }}
      >
        <Table.Body>
          {(isAddingToThisYear || yearGoals.length === 0) && (
            <NewGoalForm
              newGoal={newGoal}
              setNewGoal={setNewGoal}
              onSave={onAddGoal}
              onCancel={onCancelAdd}
              onKeyDown={onKeyDown}
            />
          )}

          <SortableContext
            items={yearGoals.map(goal => goal.id)}
            strategy={verticalListSortingStrategy}
          >
            {yearGoals.map((goal, index) => (
              <GoalRow
                key={`${goal.id}-${year}`}
                goal={goal}
                index={index}
                year={parseInt(year, 10)}
                editingId={editingId}
                editData={editData}
                setEditData={setEditData}
                startEditing={startEditing}
                saveEdit={saveEdit}
                cancelEdit={cancelEdit}
                deleteGoal={deleteGoal}
                copyGoal={copyGoal}
                recentlyMovedGoalId={recentlyMovedGoalId}
                currentTargetPosition={currentTargetPosition}
                activeGoal={activeGoal}
              />
            ))}
          </SortableContext>
        </Table.Body>
      </Table.Root>
    </Flex>
  );
};

export default YearTable;
